import { useShowAviso } from "services/app/hooks/show-aviso";
import { TransferenciaFormRef } from "../../dialog-transferencia"
import { useCadastros } from "services/app/hooks/cadastros";
import { useHistory } from "react-router-dom";
import { usePostTransferencia } from "data/api/gestao/transferencia/post-transferencia";
import { useCallback, useEffect } from "react";
import { EnumStatusTransferencia } from "model/enums/enum-status-transferencia";
import { Button, Grid } from "@material-ui/core";
import { RoundConfirmIcon } from "views/components/icons/aceito-icon";
import { FormTransferencia } from "views/components/form/master/transferencia/form-transferencia";
import { TransferenciaGetModel } from "model/api/gestao/transferencia/transferencia-get-model";
import { useSessaoAtual } from "services/app";
import { isEmpty } from "lodash";
import { guidEmpty } from "utils/guid-empty";

export interface CadastroTransferenciaProps {
    formRef: React.RefObject<TransferenciaFormRef>
    carregando: boolean;
}

export const CadastroTransferencia = ({ formRef, carregando }: CadastroTransferenciaProps) => {
    const { showAviso } = useShowAviso();

    const { fecharDialogTransferencia } = useCadastros();

    const { getEmpresa } = useSessaoAtual();

    const { push } = useHistory();

    const { postTransferencia, carregando: carregandoPost } = usePostTransferencia();

    const loading = carregando || carregandoPost

    const handleSubmit = useCallback(async (model: TransferenciaGetModel) => {
        try {
            const postModel = {
                status: EnumStatusTransferencia.Pendente,
                empresaId: getEmpresa().Id,
                contaBancariaId: isEmpty(model.contaBancariaId) ? model.contaBancariaId = guidEmpty() : model.contaBancariaId,
                transferencias: [model]
            }

            const res = await postTransferencia(postModel);

            if (res.erro) throw res.erro

            const data = res.resultado?.data;

            if (data?.list[0].status === EnumStatusTransferencia.Rejeitada) {
                push('/inicial/transferencias/gerenciar/transferencia/' + data.list[0].id);
                return
            }
            fecharDialogTransferencia();
            push('/inicial/transferencias');
            showAviso('success', 'Transferência adicionada com sucesso!')
        } catch (e: any) {
            showAviso('error', e.message, undefined, true)
        }
    }, [fecharDialogTransferencia, getEmpresa, postTransferencia, push, showAviso])

    const fillForm = useCallback(() => {
        formRef.current?.fillForm(new TransferenciaGetModel());
    }, [formRef])

    useEffect(() => {
        fillForm();
    }, [fillForm])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormTransferencia
                    loading={loading}
                    showLoading
                    onSubmit={handleSubmit}
                    ref={formRef}
                    preencherConfigAuto
                />
            </Grid>
            <Grid item xs={12} container justifyContent='flex-end' alignItems="center">
                <Button variant='contained' color='primary' size='small' onClick={() => formRef.current?.submitForm()}>
                    <RoundConfirmIcon tipo='BUTTON_PRIMARY' />
                    Confirmar
                </Button>
            </Grid>
        </Grid>
    )

}

